import { ASSIGN_CHAUFFEUR, ASSIGN_CHAUFFEUR_EMPTY, ASSIGN_CHAUFFEUR_ERROR, ASSIGN_CHAUFFEUR_SUCCESS } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AssignChauffeur = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_CHAUFFEUR:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ASSIGN_CHAUFFEUR_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ASSIGN_CHAUFFEUR_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ASSIGN_CHAUFFEUR_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AssignChauffeur;
